import type { CommodityUnderlying } from './commodity';
import type { CreditUnderlying } from './credit';
import type { EquityUnderlying } from './equity';
import type { ForexUnderlying } from './forex';
import type { RateUnderlying } from './rate';

export type Underlying = CommodityUnderlying | CreditUnderlying | EquityUnderlying | ForexUnderlying | RateUnderlying;

export function asEquityUnderlying(underlying: Underlying) {
  if (underlying.asset !== 'Equity') {
    return undefined;
  }
  return underlying as EquityUnderlying;
}

type UnderlyingWithoutAsset<T> = Omit<T, 'asset'>;
export type UnderlyingUnion = UnderlyingWithoutAsset<CommodityUnderlying> &
  UnderlyingWithoutAsset<CreditUnderlying> &
  UnderlyingWithoutAsset<EquityUnderlying> &
  UnderlyingWithoutAsset<ForexUnderlying> &
  UnderlyingWithoutAsset<RateUnderlying>;

export type UnderlyingAssetType = Underlying['asset'];
